<template>
  <div class="content">
    <main v-html="content"></main>
    <div class="download">
      <div class="gif">
        <v-row>
          <v-col v-for="(item, i) in expression" :key="i" cols="12" sm="4">
            <a :href="item.url" :download="item.name">
              <img :src="item.url" :alt="item.name" />
            </a>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: {
    content: {
      type: String,
      required: true,
    },
    expression: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin: 30px 20px;
  text-align: left;
  .download {
    .gif {
      text-align: center;
    }
    img {
      max-width: 240px;
      height: auto;
    }
  }
}

@media only screen and (max-width: 450px) {
  .content {
    .download {
      img {
        max-width: 180px;
        -webkit-touch-callout: default;
      }
    }
  }
}
</style>
<style lang="scss">
.newsContent {
  .newsIntro {
    .middle {
      .content {
        color: #fff;
        img {
          max-width: 100%;
          height: auto;
        }
      }
    }
  }
}
</style>
